export default "__VITE_ASSET__CKJU1tTH__"